import { css } from 'styled-components';
import { useTransportIsChangingFilters } from './ChangeTransportFiltersProvider';

export function FilterLoadingLayer(props: { origin: TransportFiltersOrigin }) {
  const { isChanging, changingFilter } = useTransportIsChangingFilters();
  return (
    <div
      css={css`
        position: absolute;
        top: -8px;
        bottom: 0;
        left: -8px;
        right: -8px;
        background: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer02};
        opacity: ${isChanging && changingFilter !== props.origin ? 0.7 : 0};
        visibility: ${isChanging && changingFilter !== props.origin ? 'visible' : 'hidden'};
        transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      `}
    />
  );
}
